import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MultiCityRecentSearchService,
  RetrieveSearchService as RetrieveSearchServiceShared
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { SBW_TIMEOUT } from '../constants/common.constants';
import { FlightShopWidgetTemplates } from '../constants/flight-shop.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import {
  RetrieveSearchMcResponse,
  RetrieveSearchOwRtResponse
} from '../models/core-apis/retrieve-search.interfaces';

@Injectable({
  providedIn: 'root'
})
export class RetrieveSearchService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService,
    private multiCityRecentSearchService: MultiCityRecentSearchService,
    private retrieveSearchService: RetrieveSearchServiceShared
  ) {}

  getRetrieveSearchOwRt(
    flightShopTemplateType: FlightShopWidgetTemplates
  ): Observable<RetrieveSearchOwRtResponse[]> {
    if (flightShopTemplateType === FlightShopWidgetTemplates.MODIFY) {
      return this.retrieveSearchService.getRetrieveSearchContent$() as unknown as Observable<
        RetrieveSearchOwRtResponse[]
      >;
    }

    return new ApiBuilder<string, RetrieveSearchOwRtResponse[]>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.RETRIEVE_SEARCH_OW_RT)
      .queryParams(
        `?searchType=RecentSearchesJSON&cacheBustParam=${new Date().valueOf()}`
      )
      .method(HttpRequestMethods.GET)
      .timeOut(SBW_TIMEOUT.COMMON)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  getRetrieveSearchMc(
    retrieveSearchMcCacheKey: string,
    flightShopTemplateType: FlightShopWidgetTemplates
  ): Observable<RetrieveSearchMcResponse> {
    if (flightShopTemplateType === FlightShopWidgetTemplates.MODIFY) {
      return this.multiCityRecentSearchService
        .recentSearchMultiCityObservable$ as unknown as Observable<RetrieveSearchMcResponse>;
    }

    return new ApiBuilder<string, RetrieveSearchMcResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.RETRIEVE_SEARCH_MC)
      .method(HttpRequestMethods.GET)
      .queryParams(`?CacheKey=${retrieveSearchMcCacheKey}`)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
